import { useCallback, useState } from 'react';

import { SubmitQuizDialogTypes } from '../SubmitQuizDialog/types';

interface Params {
  getUnansweredQuestions: () => number;
  showConfirmation?: boolean;
  onSubmitQuiz: VoidFunction;
}

const useSubmitQuizDialog = ({
  getUnansweredQuestions,
  showConfirmation = true,
  onSubmitQuiz,
}: Params) => {
  const [showDialog, setShowDialog] = useState<{ type: SubmitQuizDialogTypes } | null>(null);

  const onSubmit = useCallback(() => {
    const unansweredQuestions = getUnansweredQuestions();
    if (unansweredQuestions > 0) {
      setShowDialog({ type: 'unanswered' });
    } else if (showConfirmation) {
      setShowDialog({ type: 'confirmation' });
    } else {
      onSubmitQuiz();
    }
  }, [getUnansweredQuestions, onSubmitQuiz, showConfirmation]);

  const onClose = useCallback(() => {
    setShowDialog(null);
  }, []);

  return { showDialog, onSubmit, onClose };
};

export default useSubmitQuizDialog;
